import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Comprehensive fix for ResizeObserver errors

// Override console.error
const consoleError = console.error;
console.error = (...args) => {
  const firstArg = args[0];
  if (
    typeof firstArg === 'string' &&
    (firstArg.includes('ResizeObserver loop') || 
     firstArg.includes('ResizeObserver loop completed with undelivered notifications'))
  ) {
    return;
  }
  consoleError(...args);
};

// Override window.onerror
const originalOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true; // Prevent default error handling
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// Override addEventListener for 'error' events
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

// Override unhandledrejection
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && 
      typeof event.reason === 'object' && 
      event.reason.message && 
      event.reason.message.includes('ResizeObserver loop')) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />); 